import { For, Show, createSignal } from 'solid-js';
import type { ProjectManifest } from '../types/project';
import { projectDisplayTitle } from '../types/project';
import { PixelIcon } from './PixelIcon';
import { ProjectIcon } from './ProjectIcon';

interface StartMenuProps {
  open: boolean;
  projects: ProjectManifest[];
  close: () => void;
  openProjects: () => void;
  openProject: (project: ProjectManifest) => void;
  openAbout: () => void;
  openStory: () => void;
  openSocial: () => void;
  openSettings: () => void;
  openShutdown: () => void;
}

export function StartMenu(props: StartMenuProps) {
  const [projectMenuOpen, setProjectMenuOpen] = createSignal(false);

  function run(action: () => void) {
    action();
    props.close();
    setProjectMenuOpen(false);
  }

  return (
    <Show when={props.open}>
      <nav
        id="start-menu"
        class="start-menu"
        aria-label="Start menu"
        onClick={(event) => event.stopPropagation()}
      >
        <div class="start-menu-brand" aria-hidden="true">
          <span>Ivan Sivák</span>
          <strong>98</strong>
        </div>
        <div class="start-menu-items">
          <div
            class="start-menu-submenu-host"
            onMouseEnter={() => setProjectMenuOpen(true)}
            onMouseLeave={() => setProjectMenuOpen(false)}
          >
            <button
              class="start-menu-item"
              onClick={() => setProjectMenuOpen((value) => !value)}
              aria-expanded={projectMenuOpen()}
            >
              <PixelIcon name="folder" size={28} />
              <span><u>P</u>rograms</span>
              <b class="menu-arrow">▶</b>
            </button>
            <Show when={projectMenuOpen()}>
              <div class="start-submenu" onMouseEnter={() => setProjectMenuOpen(true)}>
                <button class="start-menu-item compact" onClick={() => run(props.openProjects)}>
                  <PixelIcon name="folder" size={22} />
                  <span>Project Explorer</span>
                </button>
                <div class="menu-separator" />
                <For each={props.projects.filter((project) => project.status === 'published')}>
                  {(project) => (
                    <button class="start-menu-item compact" onClick={() => run(() => props.openProject(project))}>
                      <ProjectIcon project={project} size={22} />
                      <span>{projectDisplayTitle(project)}</span>
                    </button>
                  )}
                </For>
              </div>
            </Show>
          </div>

          <button class="start-menu-item" onClick={() => run(props.openStory)}>
            <PixelIcon name="document" size={28} />
            <span><u>D</u>ocuments</span>
          </button>
          <button class="start-menu-item" onClick={() => run(props.openSocial)}>
            <PixelIcon name="network" size={28} />
            <span><u>F</u>avorites &amp; links</span>
          </button>
          <div class="menu-separator" />
          <button class="start-menu-item" onClick={() => run(props.openSettings)}>
            <PixelIcon name="settings" size={28} />
            <span><u>S</u>ettings</span>
          </button>
          <button class="start-menu-item" onClick={() => run(props.openAbout)}>
            <PixelIcon name="info" size={28} />
            <span><u>H</u>elp / About</span>
          </button>
          <div class="menu-separator" />
          <button class="start-menu-item" onClick={() => run(props.openShutdown)}>
            <PixelIcon name="shutdown" size={28} />
            <span>Sh<u>u</u>t Down...</span>
          </button>
        </div>
      </nav>
    </Show>
  );
}
